/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Create_DescriptionInputs */

const en_admin_invite_codes_create_description = /** @type {(inputs: Admin_Invite_Codes_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate one or more invite codes. Random codes are produced automatically.`)
};

/**
* | output |
* | --- |
* | "Generate one or more invite codes. Random codes are produced automatically." |
*
* @param {Admin_Invite_Codes_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_create_description = /** @type {((inputs?: Admin_Invite_Codes_Create_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Create_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_create_description(inputs)
});
export { admin_invite_codes_create_description as "admin.invite_codes.create_description" }